import {Badge, Icon} from "@chakra-ui/react";
import {ArrowPathIcon, CheckIcon} from "@heroicons/react/16/solid";
import {memo} from "react";

export const SaveState = memo(({saving}: {saving: boolean}) => {
  return (
    <Badge
      colorPalette={saving ? "blue" : "green"}
      shadow="md"
      transitionProperty="common"
      transitionDuration="moderate"
      size="sm"
    >
      <Icon asChild boxSize="1em" animation={saving ? "spin" : undefined}>
        {saving ? <ArrowPathIcon /> : <CheckIcon />}
      </Icon>
      {saving ? "Saving..." : "Saved"}
    </Badge>
  );
});
